import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiPostFile } from "../api/api";

export default function AuditoriaForm() {
  const { localId } = useParams();
  const navigate = useNavigate();

  const [limpeza, setLimpeza] = useState("OK");
  const [luz, setLuz] = useState("OK");
  const [obs, setObs] = useState("");
  const [foto, setFoto] = useState(null);

  const [lat, setLat] = useState("");
  const [lon, setLon] = useState("");

  async function submit(e) {
    e.preventDefault();

    const form = new FormData();
    form.append("local_id", localId);
    form.append("limpeza", limpeza);
    form.append("luz", luz);
    form.append("obs", obs);
    form.append("latitude", lat);
    form.append("longitude", lon);
    form.append("foto", foto);

    await apiPostFile("/auditorias/", form);

    alert("Auditoria registada!");
    navigate(`/projetos`);
  }

  return (
    <div style={{ padding: 20 }}>
      <h1>Auditar Local #{localId}</h1>
      <form onSubmit={submit}>
        <label>Limpeza:</label>
        <select value={limpeza} onChange={(e) => setLimpeza(e.target.value)}>
          <option value="OK">OK</option>
          <option value="NOK">NOK</option>
        </select>

        <label>Luz:</label>
        <select value={luz} onChange={(e) => setLuz(e.target.value)}>
          <option value="OK">OK</option>
          <option value="NOK">NOK</option>
        </select>

        <textarea
          placeholder="Observações"
          value={obs}
          onChange={(e) => setObs(e.target.value)}
        />

        <input
          placeholder="Latitude"
          value={lat}
          onChange={(e) => setLat(e.target.value)}
        />

        <input
          placeholder="Longitude"
          value={lon}
          onChange={(e) => setLon(e.target.value)}
        />

        <input type="file" onChange={(e) => setFoto(e.target.files[0])} />

        <button type="submit">Submeter</button>
      </form>
    </div>
  );
}
